export default __webpack_public_path__ + "static/media/livingroom.da055ed7.png";